<template>
  <!-- 轮播图 -->
  <div :class="isH5 ? 'h5-banner-wrap-bg' : 'banner-wrap-bg'">
    <div
      :class="{
        'electron-banner-wrap': isElectron,
        'banner-wrap': !isElectron,
      }"
    >
      <div class="swiper-container banner-container">
        <!-- :class="isH5 ? 'mobile-swiper-container' : 'pc-swiper-container'" -->
        <swiper
          @slideChange="slideChange"
          :options="handleSwiperOption"
          ref="bannerSwiper"
          class="pc-swiper-container"
        >
          <swiper-slide v-for="(item, index) in bannerList" :key="item.id">
            <div>
              <img
                v-if="!isElectron && !isH5"
                class="banner-img-bg"
                :src="bannerBgList[index]"
                alt=""
              />
              <img
                class="banner-img"
                :src="item.img_url + '?imageView2/0/w/1200'"
                alt=""
                :data_href="item.href"
                :data_type="item.href_type"
                :data_id="item.id"
              />
            </div>
          </swiper-slide>
          <div
            class="swiper-button-prev"
            slot="button-prev"
            v-show="bannerList.length > 1 && !isH5"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
            v-show="bannerList.length > 1 && !isH5"
          ></div>
          <div
            class="swiper-pagination"
            slot="pagination"
            v-show="bannerList.length > 1"
          ></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    bannerList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    let that = this;
    return {
      isMobile: isMobile(),
      isElectron: window.isElectron,
      activeIndex: 0, //当前展示图片下标
      bannerBg: "", //背景图-高斯模糊
      bannerBgList: [], //背景图-高斯模糊
      isH5: isH5(),
      pcOption: {
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 8000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        clickable: true,
        on: {
          click: function (e) {
            console.log(e, "32px");
            let type = Number(e.target.getAttribute("data_type") || "");
            let href = e.target.getAttribute("data_href") || "";
            let id = e.target.getAttribute("data_id") || "";
            let obj = {
              href,
              href_type: type,
              id,
            };
            that.jumpUrl(obj);
          },
        },
      },
      mobileOption: {
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
        },
        grabCursor: true,
        loop: true,
        speed: 1000,
        preventClicks: false,
        preventClicksPropagation: false,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
      },
    };
  },
  methods: {
    slideChange() {
      // 监听图片切换
      let activeIndex = this.$refs.bannerSwiper.swiper.activeIndex;
      let bannerLength = this.bannerList?.length || 0;
      activeIndex = this.$refs.bannerSwiper.swiper.activeIndex % bannerLength;
      if (activeIndex === 0) {
        this.activeIndex = bannerLength - 1;
      } else {
        this.activeIndex = activeIndex - 1;
      }
    },
    jumpUrl(item) {
      if (item.href_type === 2) {
        if (window.isElectron) {
          window.openUrlByExternal(item.href);
        } else {
          window.open(item.href);
        }
      } else if (item.href_type === 3) {
        let url = `/details/${item.id}`;
        if (window.isElectron || this.isMobile) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    // activeIndex: {
    //   handler: function (newVal, oldVal) {
    //     if (newVal !== oldVal) {
    //       this.bannerBg =
    //         this.bannerList[newVal].img_url +
    //         "?imageView2/0/w/600|imageMogr2/blur/50x50";
    //     }
    //   },
    //   immediate: true,
    // },
    bannerList: {
      handler: function (newVal) {
        if (newVal.length) {
          this.bannerBgList = newVal.map((item) => {
            return item.img_url + "?imageView2/0/w/600|imageMogr2/blur/50x50";
          });
        } else {
          this.bannerBgList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    handleSwiperOption() {
      if (this.bannerList.length > 1) {
        if (window.isElectron) {
          let option = {
            ...this.pcOption,
            effect: "coverflow",
            coverflowEffect: {
              rotate: 0,
              stretch: 48,
              depth: 200,
              modifier: 2,
              slideShadows: false,
            },
            autoplay: {
              delay: 5000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            speed: 500,
            slidesPerView: "auto",
            watchSlidesVisibility: true,
            centeredSlides: true, // 设定为true时，活动块会居中，
            slideToClickedSlide: true, // 设置为true则点击slide会过渡到这个slide。
            lazyLoading: true,
          };
          return option;
        } else {
          return this.pcOption;
        }
      } else {
        let option = { ...this.pcOption };
        option.loop = false;
        return option;
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss" scoped>
.banner-wrap-bg {
  width: 100%;
  height: 390px;
  background-size: 100% auto;
  background-position: center;
  margin-top: -50px;
  overflow: hidden;
}
.banner-wrap-bg .banner-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  min-height: auto;
  .pc-swiper-container {
    .swiper-slide {
      position: relative;
      .title {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 8px;
        background: rgba($color: #000000, $alpha: 0.3);
        font-weight: 600;
        font-size: 14px;
        border-radius: 0 0 12px 12px;
        color: #fff;
      }
    }
    ::v-deep .swiper-wrapper {
      height: 390px !important;
      .swiper-slide {
        width: 100% !important;
        margin: 0 auto;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: 32px;
      height: 32px;
      top: calc(50% + 50px);
      transform: translateY(-100%);
    }
    .swiper-button-prev {
      left: calc((100% - 1200px) / 2 + 20px);
      &:hover::after {
        background: url("../../../assets/images/banner-pre-active.png");
        background-size: 100% 100%;
      }
    }
    .swiper-button-next {
      right: calc((100% - 1200px) / 2 + 20px);
      &:hover::after {
        background: url("../../../assets/images/banner-pre-active.png");
        background-size: 100% 100%;
      }
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      background: url("../../../assets/images/banner-pre.png");
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      font-family: none;
      display: inline-block;
      content: "";
    }
    .swiper-button-next {
      top: calc(50% + 50px);
      transform: rotate(180deg) translateY(100%);
    }
    .banner-img-bg {
      width: 100%;
      height: 390px;
    }
    .banner-img {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      width: 1200px;
      height: 340px;
      cursor: pointer;
      object-fit: cover;
    }
  }
  .mobile-swiper-container {
    .banner-img {
      width: 9.6rem;
      height: 3.2rem;
      border-radius: 0.21rem;
      object-fit: cover;
    }
    .swiper-slide {
      position: relative;
      .title {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.2);
        font-weight: 600;
        padding: 0.11rem;
        font-size: 0.35rem;
        border-radius: 0.21rem;
      }
    }

    ::v-deep .swiper-pagination-bullet {
      width: 0.27rem;
      border-radius: 0.11rem;
      margin: 0 0.11rem;
    }
    ::v-deep .swiper-pagination-bullet-active {
      background-color: $saas-theme-color;
      border-radius: 0.11rem;
    }
  }
  .swiper-pagination-bullets {
    width: auto;
    left: calc((100% - 1200px) / 2 + 32px);
    display: inline-flex;
    position: relative;
    top: -50px;
  }
  ::v-deep .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
    background: #ffffff;
    border-radius: 3px;
    opacity: 0.5;
    margin: 0 2px;
  }
  ::v-deep .swiper-pagination-bullet-active {
    width: 10px;
    height: 5px;
    background: #ffffff;
    border-radius: 3px;
    opacity: 0.9;
  }
}

// 客户端样式
.electron-banner-wrap {
  width: 980px;
  min-height: auto;
  margin: 0 auto;
  &:hover {
    .swiper-button-next,
    .swiper-button-prev {
      display: block !important;
    }
  }
  .pc-swiper-container {
    .swiper-slide {
      position: relative;
      .title {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 8px;
        background: rgba($color: #000000, $alpha: 0.3);
        font-weight: 600;
        font-size: 14px;
        border-radius: 0 0 12px 12px;
        color: #fff;
      }
    }
    ::v-deep .swiper-wrapper {
      height: 140px !important;
      .swiper-slide {
        width: 500px !important;
        margin: 0 auto;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
      width: 18px;
      height: 18px;
    }
    .swiper-button-prev {
      left: 20px;
      transform: translateY(5px);
    }
    .swiper-button-next {
      right: 20px;
      transform: translateY(5px) rotate(180deg);
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      background: url("../../../assets/images/pre-icon.png");
      background-size: 100% 100%;
      width: 18px;
      height: 18px;
      font-family: none;
      display: inline-block;
      content: "";
    }
    .banner-img {
      height: 140px;
      border-radius: 12px;
      width: 100%;
      cursor: pointer;
      object-fit: cover;
    }
  }
  .swiper-pagination-bullets {
    width: auto;
    left: 50%;
    transform: translate(-50%, 0);
    display: inline-flex;
    position: relative;
    top: -2px;
  }
  ::v-deep .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #858687;
    opacity: 0.5;
  }
  ::v-deep .swiper-pagination-bullet-active {
    opacity: 1;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    position: relative;
    & > div::after {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.4);
      border-radius: 12px;
    }
  }
}

// h5样式
.h5-banner-wrap-bg {
  padding: 0.32rem 0.32rem 0;

  ::v-deep .swiper-wrapper {
    width: 9.36rem;
    height: 2.67rem;
    .swiper-slide {
      margin: 0 auto;
    }
  }
  .banner-container {
    height: 2.67rem;
  }
  .banner-img {
    width: 100%;
    height: 2.67rem;
    border-radius: 0.32rem;
    object-fit: cover;
  }
  .swiper-pagination-bullets {
    width: auto;
    left: 50%;
    transform: translate(-50%, 0);
    display: inline-flex;
    position: relative;
    bottom: 0.93rem;
  }
  ::v-deep .swiper-pagination-bullet {
    width: 0.08rem;
    height: 0.08rem;
    background: #000000;
    border-radius: 0.04rem;
    opacity: 0.3;
    margin: 0 0.03rem;
  }
  ::v-deep .swiper-pagination-bullet-active {
    width: 0.13rem;
    height: 0.08rem;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 0.04rem;
  }
}
</style>
<style lang="scss">
#electron-main .home-page-wrap {
  background: transparent;
  .banner-wrap-bg {
    width: 100%;
    height: auto;
    margin-top: 0;
  }
}
</style>
